import React from 'react';
import { Check, X, Minus } from 'lucide-react';

function Cell({ value, highlight }) {
  if (value === true) return <span className="inline-flex items-center gap-1.5 font-medium text-emerald-700" aria-label="Ja"><Check className="h-4 w-4" aria-hidden="true" /> Ja</span>;
  if (value === false) return <span className="inline-flex items-center gap-1.5 text-gray-500" aria-label="Nein"><X className="h-4 w-4 text-red-500" aria-hidden="true" /> Nein</span>;
  if (value === null || value === undefined || value === '') return <span className="inline-flex items-center gap-1.5 text-gray-400" aria-label="Nicht verfügbar"><Minus className="h-4 w-4" aria-hidden="true" /> –</span>;
  if (typeof value === 'object' && value.text) {
    return <span className={`inline-flex items-start gap-1.5 ${value.ok === false ? 'text-gray-600' : value.ok ? 'text-emerald-700 font-medium' : ''}`}>{value.ok === true && <Check className="mt-0.5 h-4 w-4 flex-none" aria-hidden="true" />}{value.ok === false && <X className="mt-0.5 h-4 w-4 flex-none text-red-500" aria-hidden="true" />}<span>{value.text}</span></span>;
  }
  return <span className={highlight ? 'font-semibold text-gray-900' : ''}>{value}</span>;
}

/**
 * columns: [{ key, label, highlight?: bool }]  — erste Spalte = Kriterium
 * rows:    [{ label, note?, values: { [key]: true|false|string|{text, ok} } }]
 */
export function ComparisonTable({ columns, rows, caption, footnote, testId = 'comparison-table' }) {
  return (
    <div data-testid={testId}>
      <div className="hidden md:block overflow-hidden rounded-2xl ring-1 ring-gray-200 bg-white">
        <table className="w-full text-sm">
          {caption && <caption className="sr-only">{caption}</caption>}
          <thead>
            <tr className="bg-[#f4f8f5]">
              <th scope="col" className="px-5 py-4 text-left font-semibold text-gray-700 w-[34%]">Kriterium</th>
              {columns.map(c => (
                <th key={c.key} scope="col" className={`px-5 py-4 text-left font-semibold ${c.highlight ? 'text-emerald-800 bg-emerald-50' : 'text-gray-700'}`}>{c.label}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {rows.map((r, i) => (
              <tr key={i} className="align-top">
                <th scope="row" className="px-5 py-4 text-left font-medium text-gray-900">
                  {r.label}
                  {r.note && <span className="block text-xs font-normal text-gray-500 mt-0.5">{r.note}</span>}
                </th>
                {columns.map(c => (
                  <td key={c.key} className={`px-5 py-4 ${c.highlight ? 'bg-emerald-50/40' : ''}`}><Cell value={r.values[c.key]} highlight={c.highlight} /></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="md:hidden space-y-3">
        {rows.map((r, i) => (
          <div key={i} className="rounded-xl bg-white ring-1 ring-gray-200 p-4" data-testid={`${testId}-card-${i}`}>
            <p className="font-semibold text-gray-900">{r.label}</p>
            {r.note && <p className="text-xs text-gray-500 mt-0.5">{r.note}</p>}
            <dl className="mt-3 space-y-2">
              {columns.map(c => (
                <div key={c.key} className={`flex items-start justify-between gap-3 rounded-lg px-3 py-2 ${c.highlight ? 'bg-emerald-50' : 'bg-gray-50'}`}>
                  <dt className="text-xs font-semibold text-gray-600 pt-0.5">{c.label}</dt>
                  <dd className="text-sm text-right"><Cell value={r.values[c.key]} highlight={c.highlight} /></dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </div>
      {footnote && <p className="mt-4 text-xs text-gray-500">{footnote}</p>}
    </div>
  );
}

export default ComparisonTable;
